import PageHeader from '../layout/PageHeader'
import TodayIcon from '@mui/icons-material/Today'
import PageContainer from '../layout/PageContainer'
import { Calendar, momentLocalizer } from 'react-big-calendar'
// eslint-disable-next-line
let moment = require('moment')
// eslint-disable-next-line
require('moment/locale/pl');

moment.locale('pl')

const localizer = momentLocalizer(moment)

const Home = () => {
  return (
    <>
      <PageHeader
        icon={<TodayIcon fontSize="large" />}
        title="Kalendarz"
        subtitle="Tutaj znajdziesz swoje zadania na najbliższy czas"
      />
      <PageContainer>
        <Calendar
          localizer={localizer}
          events={[
            {
              id: 0,
              title: 'Spotkanie',
              start: new Date(2021, 9, 11, 14, 30, 0, 0),
              end: new Date(2021, 9, 11, 17, 30, 0, 0),
            },
          ]}
          startAccessor="start"
          endAccessor="end"
          messages={{
            month: 'Miesiąc',
            day: 'Dzień',
            week: 'Tydzień',
            today: 'Dzisiaj',
            agenda: 'Zadania',
            allDay: 'Cały dzień',
            previous: 'Poprzedni',
            next: 'Następny',
            date: 'Data',
            noEventsInRange: 'Nie ma żadnych zadań w najbliższym czasie',
            time: 'Czas',
            tomorrow: 'Jutro',
            work_week: 'Tydzień roboczy',
            yesterday: 'Wczoraj',
          }}
          style={{ height: 600 }}
        />
      </PageContainer>
    </>
  )
}

export default Home
